import { useQuery, UseQueryResult } from 'react-query';
import { KiloGLMFlowRetrieve } from 'types';
import { client } from 'utils/api-client';

function useKiloGLMFLow(
  glmFlowId: string | undefined | null,
): UseQueryResult<{ data: KiloGLMFlowRetrieve }> {
  return useQuery(['kilo-glm-flows', glmFlowId], () => client.get(`kilo-glm-flows/${glmFlowId}/`), {
    enabled: !!glmFlowId,
  });
}

export default useKiloGLMFLow;
